
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Axios from 'axios';
import { DIV } from 'src/components/CustomStyledComponents';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import usePageValidation from 'src/hooks/usePageValidation';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { guardarLead } from 'src/services';
import PagoRoll from './ButtonsPago/PagoRoll';
import PlaceToPay from './ButtonsPago/PlaceToPay';
import Mx365 from './ButtonsPago/Mx365';
import PlaceToPayCopyLink from './ButtonsPago/PlaceToPayCopyLink';
import GenericButton from './ButtonsPago/GenericButton';
import NotificarClienteP2p from './ButtonsPago/NotificarClienteP2p';
import Impuestos from './Impuestos';
import TerminosCondicionesCheck from './TerminosCondicionesCheck';
import { urlEditVigencia } from 'src/services/urls';
import { useLocation,  } from "react-router"
import './styles.scss';
import Stripe from './ButtonsPago/Stripe';

const PaginaPago = ({ cotizacion, idCotizacion, ...props }) => {

  // const { cotizacion, idCotizacion } = useCotizacion();

  const { valoresPagar } = cotizacion;
  const { loadingState } = usePaginaPago();
  const location = useLocation()



  const { execEvent, isLoadingCallbacks } = usePageValidation('paginaPago');

  const textos = cotizacion?.configuracion?.textos?.paginaPago ?? ""
  const [pageProps, setPageProps] = useState({
    titleValues: textos?.titulo || 'Realiza tu pago de forma segura',
    subtitleValues: textos?.subtitulo ?? "",
    labelPagar: <h2 className="total__pagar font-weight-bold mt-2">{cotizacion?.moneda?.signo} {valoresPagar?.total} {cotizacion?.moneda?.sigla} </h2>,
    impuestos: [],
    moneda: '$',
    showValues: true,
    goBack: `/newPaginaCompra/${idCotizacion}`,
  });

  const init = useCallback(async () => {
    await execEvent('initCallback', { pageProps, setPageProps });
    const { finVigencia = '', inicioVigencia = '' } = cotizacion;
    let body = {
      idCotizacion,
      fecha: inicioVigencia || new Date().toDateString(),
      fechaFin: finVigencia ?? ''
    };
    //const { data } = await 
    Axios.post(urlEditVigencia, JSON.stringify(body));

    setPageProps({
      ...pageProps,
      labelPagar: <h2 className="total__pagar font-weight-bold mt-2">{cotizacion?.moneda?.signo} {valoresPagar?.total} {cotizacion?.moneda?.sigla} {['Indefinido', 'mensual'].find(e => e === cotizacion?.producto?.periocidadPago) && 'mensuales'} </h2>,
    })


  }, [isLoadingCallbacks]);

  const botonesPagoComponent = useMemo(() => {


    const filterNoNull = (item) => item !== null;

    //filtra por tipo de pago si es "boton de pagos", "roll",etc
    const filterByTipo = (tipo: string) => (item) => item.tipo === tipo;

    //si tiene la propiedad on show filtra por el flujo 
    const filterOnShow = (flujo) => (item) => {
      if (!!item?.onShow) {
        const show = item?.onShow?.find(data => `${data}` === `${flujo}`)
        if (show) return item
      } else return item
    }
    //filtra por el pago seleccionado desde todos los pagos que tiene la empresa
    const filterSeleccionado = (formaPago) => (item) => {
      if (!!item?.codCore) {
        if (typeof formaPago === "string") return item  // corregir en los productos que devuelva array
        //  no funcionara si devuelve string 
        const show = formaPago?.find((i) => i === `${item?.codCore}`)
        console.log("filterSeleccionado:", { item, show })
        if (show) return item
      }
    }
    const mapper = (metodo, index: number) => {
      const TIPO_BOTONES = {
        placetopay: PlaceToPay,
        garantia365: Mx365,
        notificarPtpCorreoCliente: NotificarClienteP2p,
        pagoRoll: PagoRoll,
        generic: GenericButton,
        stripe: Stripe
      }
      if (metodo.codCore === 'notificarPtpCorreoCliente') {
        if (['12'].includes(cotizacion.flujoPlugin)) return null;
      }
      const Component = TIPO_BOTONES[metodo.codCore]
      return Component ? <Component key={index} {...metodo} /> : null
    };

    const botones: React.FC[] = cotizacion?.metodosPago
      .filter(filterByTipo('boton'))
      .filter(filterOnShow(cotizacion?.flujoPlugin))
      .filter(filterSeleccionado(cotizacion?.producto?.formaPago))
      .map(mapper)
      .filter(filterNoNull);

    const enlaces: React.FC[] = cotizacion?.metodosPago
      .filter(filterByTipo('enlace'))
      .filter(filterSeleccionado(cotizacion?.producto?.formaPago))
      .map(mapper)
      .filter(filterNoNull);
    return { botones, enlaces };
  }, [cotizacion?.metodosPago]);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    guardarLead(idCotizacion, `PAGINA_PAGO__INGRESO`);
  }, [])

  //@ts-ignore
  const showFranquicias = (botonesPagoComponent.botones.findIndex(({ props }) => props?.codCore === 'placetopay')) !== -1

  //@ts-ignore

  // Todo: quitar esta validacion de flujo
  const mostrarlink = [6, 7, 9, 19, 20].findIndex(i => `${i}` === `${cotizacion?.flujoPlugin}`) !== -1
  console.log("mostrarlink", mostrarlink, cotizacion?.producto?.flujo)

  return (
    <LoadingWrapper {...loadingState}>
      <DIV stylePath="paginaPago.globalStyles" className="container-fluid container-page">
        <NavbarHeader goBack={pageProps.goBack} />
        <HeaderPage progreso={70} />
        <div className="row justify-content-center">
          <div className="col-11 text-center mt-3">
            <h4 className="titulo font-weight-bold">{pageProps.titleValues}</h4>
            <p>{pageProps.subtitleValues}</p>
          </div>
          <div className="col-12 col-md-10 col-lg-8 col-xl-7 text-center">
            {pageProps.showValues && (
              <>
                {pageProps.labelPagar}
                <Impuestos impuestos={pageProps.impuestos} moneda={cotizacion?.moneda} />
              </>
            )}
          </div>
        </div>
        <div className="row justify-content-center my-3">
          <div className="col-11 col-md-10 col-lg-8 col-xl-7  mb-3" style={{ border: 'solid 1px #979797' }} />
          <div className="col-12" />
          <TerminosCondicionesCheck />
          {botonesPagoComponent.botones.length > 0 && (
            <div className="col-md-7 mt-5">
              {botonesPagoComponent.botones.length > 1 && <>
                <h4 style={{ fontWeight: 'bold' }}>FORMAS DE PAGO</h4>
                <p className="mt-1" style={{ color: '#949494', fontSize: '21px' }}>
                  Por favor, selecciona la forma de pago que prefieres
                </p>
              </>
              }
              {botonesPagoComponent.botones.length === 1 && <>
                <h4 style={{ fontWeight: 'bold' }}>FORMA DE PAGO</h4>
                <p className="mt-1" style={{ color: '#949494', fontSize: '21px' }}>
                  Por favor, selecciona la forma de pago presentada para poder continuar
                </p>
              </>
              }
              <div className="row justify-content-center flex-column  py-4" style={{ backgroundColor: '#fafafa', }}>
                <>
                  {botonesPagoComponent.botones}
                </>
              </div>
            </div>
          )}
          {botonesPagoComponent.enlaces.length > 0 && (
            <>
              <div className="col-12" />
              <div className="col-md-7 mt-3">
                <h4>Enviar correo con enlace de pago</h4>
                <div
                  className="row justify-content-center  py-4"
                  style={{ backgroundColor: '#fafafa', minHeight: '119px' }}
                >
                  <>
                    {botonesPagoComponent.enlaces}
                  </>
                </div>
              </div>
            </>
          )}
          {(`${cotizacion.producto.generarLinkPago}` === '1' || mostrarlink) && <>
            {botonesPagoComponent.botones.length === 0 && botonesPagoComponent.enlaces.length === 0 &&
              <div className="col-11 text-center">
                <h4 style={{ fontWeight: 'bold' }}>Generación de Link de Pago</h4>
                <p className="mt-1" style={{ color: '#949494', fontSize: '21px' }}>
                  Presiona el botón de generación para que se envíe el link de pago al titular
                </p>

              </div>}
            <PlaceToPayCopyLink />
          </>}

          <div className="col-12" />
          
        </div>
      </DIV>
    </LoadingWrapper >
  );
};

export default withCotizacion(PaginaPago);
